export const MapCharacteristicAndValue = (characteristic: any, value: any): Characteristic => {
    const mappedValue: ValueDefinition = {
        id: value.id,
        description: value.description,
        value: value.value,
        resource: value.resource,
        default: value.default,
    };

    const mappedCharacteristic: Characteristic = {
        id: characteristic.id,
        description: characteristic.description,
        code: characteristic.code,
        value: mappedValue,
    };

    return mappedCharacteristic;
};

export interface Characteristic {
    id: number;
    description: string;
    code: string;
    value: ValueDefinition;
}

export interface ValueDefinition {
    id?: number;
    description: string;
    value: any;
    resource: any;
    default?: number;
}

export interface MountingMaterialItem {
    materialArt: Characteristic;
    material: Characteristic;
    coating: Characteristic;
    color: Characteristic;
    height: Characteristic;
    width: Characteristic;
    length: Characteristic;
    quantity: Characteristic;

    surface?: Characteristic;
    surfaceArt?: Characteristic;
    surfaceSpecial?: Characteristic;
}

export interface BlindstockItem {
    materialArt: Characteristic;
    material: Characteristic;
    height: Characteristic;
    width: Characteristic;
    length: Characteristic;
    quantity: Characteristic;
}

export interface MountingMaterialItemToSapData {
    code: string,
    value: string
}

export interface FilterMatrixItem {
    characteristicId: number;
    valueDefinitionId: number;
}

export interface User {
    userId: number;
    fullName: string;
}

export interface NavigationItemStatus {
    success: boolean;
    warning: boolean;
    required: boolean;
}

export interface NavigationItem {
    status: string;
    itemStatus: NavigationItemStatus;
}

export enum ConfigurationContext {
    ModelSelection = 1,
    Functions = 2,
    Frame = 3,
    Measure = 4,
    DoorLeafSurface = 5,
    ExteriorAccessory = 6,
    MountingMaterial = 7,
    BlindstockMultiplex = 8,
    FurtherInformation = 9,
}

export enum DependenciesFilter {
    Values,
    Resources,
}